import GATEWAY from '@/utils/gateway'
import request from '../utils/request'

export async function doLogin(data) {
  if (!data) {
    return request(`${GATEWAY}login`);
  }
  
  let param = '?';

  for (const key in data) {
    param += `&${key}=${data[key]}`;
  }

  return request(`${GATEWAY}login${param}`);
}

export async function doLogout() {
  return request(`${GATEWAY}logout`);
}

export async function fetchClientId() {
  return request(`${GATEWAY}sponsor/cloudmusic/account/getClientToken`, {
    method: 'POST',
  })
  // return '97a8c852915da502bf5ece32a167dc5466f44c7913b0ad1b18f99bb1df202b73';
}

export async function fetchInfo() {
  return request(`${GATEWAY}sponsor/sponsor/info`, {
    method: 'POST',
  })
}

export async function proxyReq(data) {
  return request(`${GATEWAY}proxy`, {
    method: 'POST',
    body: data,
  })
}

export async function loginSelect(data) {
  return request(`${GATEWAY}login/select`, {
    method: 'POST',
    body: data,
  });
}
